import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, HostListener, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { LinkService } from '../../../_services/langhfre.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
// import { AmplitudeService } from 'src/app/_services/amplitude.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-webinars',
  templateUrl: './webinars.component.html',
  styleUrls: ['./webinars.component.scss']
})
export class WebinarsComponent implements OnInit {
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  billingInvoiceText: boolean = false;

  @HostListener('input') oninput() {

    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
    }
  }

  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private el: ElementRef,
    // public amplitudeService: AmplitudeService,
    private router: Router
  ) { 
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormDestination': ['', Validators.required],
      'contactFormInstitution': ['', Validators.required],
      'contactFormTopList': ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });

    }
    this.titleService.setTitle('Trinka Webinars');
    this.metaTagService.updateTag({ name: 'description', content: "Discover new trends, learn from industry experts, and uncover the advancments and impact of AI in academics" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka Webinars' });    
    this.metaTagService.updateTag({ property: 'og:description', content: "Discover new trends, learn from industry experts, and uncover the advancments and impact of AI in academics" });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/webinars' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Webinars' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Discover new trends, learn from industry experts, and uncover the advancments and impact of AI in academics" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/webinars' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/webinars' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/webinars' });
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  processForm() {
    // console.log("gggg")
    // if(this.contactForm.value.contactFormEmail && this.contactForm.value.contactFormName && this.contactForm.value.contactFormSubjects && this.contactForm.value.contactFormMessage){
    if (this.contactForm.valid) {
      console.log("vlaidated")
      const selectedInquiryType = this.contactForm.value.contactFormTopList;
      // Create the subject with the selected inquiry type
      const subject = `Webinar Inquiry Type: ${selectedInquiryType}`;
      var query = this.contactForm.value.contactFormName + "||" + this.contactForm.value.contactFormDestination + "||" + this.contactForm.value.contactFormInstitution + "||" + this.contactForm.value.contactFormTopList
      this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query, this.router.url).subscribe(result => {
        this.toastr.success("Thanks! We will contact you shortly.")
        this.contactForm.reset();
      }, error => {
        // this.shareService.errorHandller(error);
      })
    } else {
      // this.toastr.warning("Please fill in the necessary details on the form.")
      this.validateAllFormFields(this.contactForm);
    }
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  scrollToElementWithOffset(id: string, offset: number = 0) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }

  stopAllVideos() {
    const iframes = document.querySelectorAll('iframe.youtubeVideoForTryDemo');
    iframes.forEach((iframe: HTMLIFrameElement) => {
      iframe.src = iframe.src; // Setting src to the same value pauses the video
    });
  }

  

}
